import { Box, BoxProps, TextField, TextFieldProps } from "@mui/material";

export type FocusableBoxProps = Omit<BoxProps, "color" | "ref" | "value" | "onChange" | "defaultValue"> & {
    size?: TextFieldProps["size"],
    required?: TextFieldProps["required"],
    margin?: TextFieldProps["margin"],
    label?: TextFieldProps["label"],
    autoFocus?: TextFieldProps["autoFocus"],
    color?: TextFieldProps["color"],
    disabled?: TextFieldProps["disabled"],
    error?: TextFieldProps["error"],
    helperText?: TextFieldProps["helperText"],
    slots?: TextFieldProps["slots"],
    slotProps?: TextFieldProps["slotProps"],

    boxRef?: React.Ref<any>,
    inputRef?: React.Ref<any>,
};

export default function FocusableBox({
    children,
    boxRef,
    inputRef,
    ...props
}: FocusableBoxProps) {
    const validChildren = Boolean(children);

    return <TextField
        {...props as any}

        component={Box}

        ref={boxRef as any}
        inputRef={inputRef as any}

        slotProps={{
            ...props.slotProps,
            input: {
                ...props.slotProps?.input,
                component: Box as any,
                inputComponent: Box as any,
                sx: { width: "100%", height: "100%", cursor: "pointer", flex: "1 1 auto", ...(props.slotProps?.input as any)?.sx },
            },
            htmlInput: {
                tabIndex: 0,
                children: validChildren && children,
                component: Box as any,
                width: "100%",
                height: "100%",
                padding: 0,
                margin: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                ...props.slotProps?.htmlInput,
            },
            inputLabel: {
                shrink: validChildren ? true : undefined,
                ...props.slotProps?.inputLabel,
            }
        }}

    />
}